<template>
<div class="animated fadeIn">
  <v-client-table :data="buildings" :columns="columns" :options="options" :theme="theme" id="dataTable" ref="dataTable">
  </v-client-table>
</div>
</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'

export default {
  name: 'BuildingRevenueReport',
  props: {
    buildings: Array
  },
  data: function() {
    return {
      columns: [
        'id',
        'name',
        'floors.length',
        'total_rooms',
        'total_revenue',
      ],
      options: {
        headings: {
          'id': 'ID',
          'name': 'Name',
          'floors.length': 'Floors',
          'total_rooms': 'Rooms',
          'total_revenue': 'Bhent Received '
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
    }
  }
}
</script>
